import { render, staticRenderFns } from "./ModalExterna.vue?vue&type=template&id=53aa8b06&"
import script from "./ModalExterna.vue?vue&type=script&lang=js&"
export * from "./ModalExterna.vue?vue&type=script&lang=js&"
import style0 from "./ModalExterna.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports